import { typography, colors } from '@99designs/ui/settings';

export function getLinkColor(color: colors.Color) {
    return color === 'chameleon' ? 'currentColor' : colors[color];
}

export function getLinkSize(size: typography.FontFamilyLinksSize) {
    return `${typography.fontSizes.links[size]}px`;
}

export function getLinkFontFamily(fontFamily: typography.FontFamily) {
    return typography.fontFamilies[fontFamily];
}
